import React from 'react';
import { FormattedMessage } from 'react-intl';
import { addDataLayerEntry } from '@printdeal/data-layer-manager';
import { Tabs, RichText } from '@printdeal/ui-library';
import { Markdown } from '@printdeal/markdown/react';
import { ProductUploadSpecifications } from '../ProductUploadSpecifications';
import { IProductPage } from '../../../../types/product/productDetailPage';

interface Props {
  productPage: IProductPage
}

export const ProductTabs = ({ productPage }: Props) => {
  const { productUploadSpecifications } = productPage;
  const productTabs = productPage.productTabs || [];
  const tabs = [
    (productPage.pageLayout === 'Advanced') ? {
      title: <FormattedMessage id="product.productInfo" defaultMessage="Productinfo" />,
      content: {
        content: productPage?.description?.description,
      },
    } : undefined,
    (productUploadSpecifications?.uploadSpecifications?.length) ? {
      title: (
        <FormattedMessage
          id="product.detailPage.tabUploadSpecifications.navName"
          defaultMessage="File specifications"
        />
      ),
      content: {
        content: (
          <ProductUploadSpecifications
            uploadSpecifications={productUploadSpecifications?.uploadSpecifications}
          />
        ),
      },
    } : undefined,
    ...productTabs,
  ].filter(Boolean);
  const handleClick = (event: React.MouseEvent) => {
    const tab = event.target as HTMLElement;
    addDataLayerEntry('product_information', {
      product_tab: tab.innerText,
    });
  };

  return (
    <Tabs>
      <Tabs.List>
        {tabs.map((tab, index) => (
          <Tabs.Tab key={`tab-${String(index)}`} onClick={handleClick}>
            {tab.title}
          </Tabs.Tab>
        ))}
      </Tabs.List>
      <Tabs.Panels>
        {tabs.map((tab, index) => (
          <Tabs.Panel key={`tab-panel-${String(index)}`} unmount={false}>
            {tab.content?.content && typeof tab.content.content === 'string'
              ? <RichText><Markdown anchorTarget="_blank">{tab.content.content}</Markdown></RichText>
              : tab.content?.content}
          </Tabs.Panel>
        ))}
      </Tabs.Panels>
    </Tabs>
  );
};
